import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { TodayState } from './types'
import { state } from './state'
import { actions } from './actions'
import { mutations } from './mutations'

export const today: Module<TodayState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
}
